/**
 * Utility functions for bang-ke-hang-ban-bi-tra-lai feature
 */

/**
 * Format a date to YYYYMMDD format for API requests
 * @param dateString - The date string in YYYY-MM-DD format
 * @returns Formatted date string in YYYYMMDD format, or empty string if invalid
 */
export function formatDateToYYYYMMDD(dateString: string): string {
  if (!dateString) return '';
  return dateString;
}
